import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DocumentFieldOption, FieldSchema } from '@lsq-frontend/remote-services/ar-app';
import { LsqValidators } from '@lsq-frontend/common-ui';

export function documentRequestForm(
    hasDocuments: boolean = false,
    fieldSchema?: FieldSchema
): FormGroup {
    const fieldOption = fieldSchema?.fieldOption as DocumentFieldOption;
    const currentDocumentName = fieldSchema?.label || '';
    const currentDescription = fieldOption?.copy || '';
    const currentFormat = fieldOption?.fileExtensions || '';
    const currentScheduleRequest = fieldOption?.scheduleRequest || '';
    const currentStartDate = fieldOption?.startDate || '';
    const currentRepeatEvery = fieldOption?.repeatEvery || '';
    const currentRepeats = fieldOption?.repeats || '';

    const formGroup: FormGroup = new FormGroup({
        documentName: new FormControl(currentDocumentName, [
            Validators.required,
            LsqValidators.maxLength(250)
        ]),
        documentDescription: new FormControl(currentDescription, [
            Validators.required,
            LsqValidators.maxLength(250)
        ]),
        fileFormat: new FormControl(currentFormat, [Validators.required]),
        scheduleRequest: new FormControl(currentScheduleRequest),
        startDate: new FormControl(currentStartDate),
        repeatEvery: new FormControl(currentRepeatEvery),
        repeats: new FormControl(currentRepeats),
        hasDocuments: new FormControl(hasDocuments)
    });
    return formGroup;
}
